import { jsx } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import tableStyles from "./components/Table/styles.module.scss";
import { M as ModeType } from "./Table.js";
var HeaderCategory = /* @__PURE__ */ ((HeaderCategory2) => {
  HeaderCategory2["normal"] = "normal";
  HeaderCategory2["transparent"] = "transparent";
  HeaderCategory2["sortable"] = "sortable";
  return HeaderCategory2;
})(HeaderCategory || {});
const TableHead = ({ category = "normal", className, children, mode, ...rest }) => {
  const tableHeadClass = classNames(
    tableStyles["table__head"],
    {
      [tableStyles["table__head--normal"]]: category === "normal",
      [tableStyles["table__head--transparent"]]: category === "transparent",
      [tableStyles["table__head--sortable"]]: category == "sortable",
      [tableStyles["table__head--compact"]]: mode == ModeType.compact
    },
    className
  );
  return /* @__PURE__ */ jsx("thead", { className: tableHeadClass, ...rest, children: React__default.Children.map(children, (child) => React__default.isValidElement(child) && React__default.cloneElement(child, { mode })) });
};
export {
  HeaderCategory as H,
  TableHead as T
};
//# sourceMappingURL=TableHead.js.map
